import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BlogApiService } from '../services/blog-api.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent {

  blogPosts: any;

  constructor(@Inject(DOCUMENT) private document: Document, private blogApiService: BlogApiService, private titleService: Title) {
    //this.titleService.setTitle("Blog | RankAhead");
  }

  ngOnInit() {
    this.document.body.classList.add('toggle-sidebar');

    this.blogApiService.getBlogPosts().subscribe(blogPosts => {

      this.blogPosts = blogPosts;

    })
  }
}
